module.exports = __webpack_public_path__ + "media/images/icons/material/ban-6b7535714e50db1c575fd7ae9cb1930e.svg";